import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { SharedVariablesService } from '../services/shared-variables.service';

/**
 * Guard to check whether we have a sale channel in memory (needed for displaying some pages).
 */
@Injectable({ providedIn: 'root' })
export class DataGuard implements CanActivate {

  constructor(private router: Router,
              private sharedVariablesService: SharedVariablesService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.sharedVariablesService.saleChannel && this.sharedVariablesService.organisation && this.sharedVariablesService.transaction) {
      return true;
    }

    return false;
  }
}
